import ApiClient from '../api/index'

class BaseService {
  apiClient: ApiClient
  constructor() {
    this.apiClient = new ApiClient()
  }
}

export default BaseService
